interface InfoBoxProps {
  children: React.ReactNode
}

export default function InfoBox({ children }: InfoBoxProps) {
  return (
    <div className="bg-custom-yellow max-w-[500px] rounded-[20px] px-6 py-5">
      <p className="text-left text-base">{children}</p>
    </div>
  )
}
